import { connectCustom } from "@client/lib/misc";
import { ContainerRoot } from "@client/widgets";
import { type LoadPage } from "@client/widgets/Containers/Root/component";
import { type GenericMap, type WithChildren } from "@common/declarations";
import React from "react";
import { loadPage } from "./actions";

export default connectCustom(null, (dispatch: any) => ({
  loadPage: (path: string, qs: GenericMap<string>) => dispatch(loadPage(path, qs))
}))((props: { loadPage: LoadPage } & WithChildren) => (
  <ContainerRoot loadPage={props.loadPage}>{props.children}</ContainerRoot>
));
